import { Button } from 'component/Button'
import { Link } from 'component/Link'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { MouseEvent } from 'react'
import { buildBuyLink, Item } from 'type/Item'

type Props = {
  item: Item
  primary?: boolean
  className?: string
}

export const BuyButton = observer(({ item, primary, className }: Props) => {
  const icon = false
  const demo = useDemo()
  const { stand } = demo
  const { item_id, links } = item
  const link = buildBuyLink(links)

  const onBuyModal = useLatestCallback(async (event: MouseEvent) => {
    event.preventDefault()
    demo.openBuyModal(item)
  })

  const onBuy = useLatestCallback(async () => {
    demo.sendBuyEvent(item_id)
  })

  return (
    <Link
      className={className}
      href={stand ? undefined : link}
      hover={false}
      action={stand ? onBuyModal : onBuy}
    >
      <Button xl outline compact invert={primary} wide>
        <Space gap={6}>
          {icon && <Icon name="shopping_bag" size={15} />}
          <Typo line={16}>
            {i18n('demo.Buy')}
          </Typo>
        </Space>
      </Button>
    </Link>
  )
})
